import React from "react";
import styled from "styled-components";

const AdminContainer = styled.div`
  display: flex;
  font-family: 'Courier New', monospace;
  background: #000;
  color: #fff;
  min-height: 100vh;
  position: relative;
  overflow: hidden;
`;

const AdminContent = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 20px;
  position: relative;
  z-index: 1;
`;

const AdminLayout = ({ children }) => {
  return (
    <AdminContainer>
      <AdminContent>
        {children}
      </AdminContent>
    </AdminContainer>
  );
};

export default AdminLayout; 